export default __webpack_public_path__ + "static/media/drop-down.cdc43dfc.svg";